"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvFromFileParser = exports.getListFromEnvParser = exports.getBoolFromEnvParser = exports.getStringEnumFromEnvParser = exports.getStringFromEnvParser = exports.getNumberFromEnvParser = void 0;
var ValidationError_1 = require("./ValidationError");
var getNumberFromEnvParser = function (envName) { return function () {
    var _a;
    var envValue = (_a = process.env[envName]) === null || _a === void 0 ? void 0 : _a.trim();
    var parsedNum = parseFloat(envValue !== null && envValue !== void 0 ? envValue : '');
    if (isNaN(parsedNum)) {
        throw new ValidationError_1.ValidationError('Value is not parsable as integer', envName);
    }
    return parsedNum;
}; };
exports.getNumberFromEnvParser = getNumberFromEnvParser;
var defaultTransformFn = function (value) { return value; };
var getStringFromEnvParser = function (envName, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.allowEmptyString, allowEmptyString = _c === void 0 ? false : _c, _d = _b.pattern, pattern = _d === void 0 ? undefined : _d, _e = _b.transform, transform = _e === void 0 ? defaultTransformFn : _e;
    return function () {
        var _a;
        var envValue = (_a = process.env[envName]) === null || _a === void 0 ? void 0 : _a.trim();
        if (envValue === undefined || (!allowEmptyString && envValue.length === 0)) {
            throw new ValidationError_1.ValidationError('Value is not set or it is empty string', envName);
        }
        if (pattern) {
            var validator = new RegExp(pattern);
            if (validator.test(envValue) === false) {
                throw new ValidationError_1.ValidationError("Value does not match the regex pattern " + pattern, envName);
            }
        }
        return transform(envValue);
    };
};
exports.getStringFromEnvParser = getStringFromEnvParser;
var getStringEnumFromEnvParser = function (envName, possibleEnumValues) { return function () {
    var _a;
    var envValue = (_a = process.env[envName]) === null || _a === void 0 ? void 0 : _a.trim();
    if (envValue === undefined || envValue.length === 0 || !possibleEnumValues.includes(envValue)) {
        throw new ValidationError_1.ValidationError("Value does not match union: " + possibleEnumValues.join(' | ') + ", or it is empty string", envName);
    }
    return envValue;
}; };
exports.getStringEnumFromEnvParser = getStringEnumFromEnvParser;
var getBoolFromEnvParser = function (envName) { return function () {
    var _a;
    var envValue = (_a = process.env[envName]) === null || _a === void 0 ? void 0 : _a.trim();
    if (envValue === 'true') {
        return true;
    }
    if (envValue === 'false') {
        return false;
    }
    throw new ValidationError_1.ValidationError('Value is not parsable as boolean', envName);
}; };
exports.getBoolFromEnvParser = getBoolFromEnvParser;
var getListFromEnvParser = function (envName, valueParser) {
    if (valueParser === void 0) { valueParser = String; }
    return function () {
        var _a;
        var envValue = (_a = process.env[envName]) === null || _a === void 0 ? void 0 : _a.trim();
        var parsedArr = JSON.parse(envValue !== null && envValue !== void 0 ? envValue : '');
        if (!Array.isArray(parsedArr)) {
            throw new ValidationError_1.ValidationError('Passed value is not array', envName);
        }
        return parsedArr.map(function (i) { return valueParser(i); });
    };
};
exports.getListFromEnvParser = getListFromEnvParser;
var isBrowser = typeof window === 'object';
exports.getEnvFromFileParser = isBrowser
    ? function () {
        throw new Error("You cant import 'getEnvFromFileParser' in the browser");
    }
    :
        require('./node/parsers').getEnvFromFileParser;
